import { TrendingUp, TrendingDown, Shield } from 'lucide-react'

export type BuilderTabType = 'upsells' | 'downsells' | 'fallbacks'

interface BuilderTabsProps {
  activeTab: BuilderTabType
  onChange: (tab: BuilderTabType) => void
}

const TABS: { id: BuilderTabType; label: string; icon: typeof TrendingUp; disabled?: boolean }[] = [
  { id: 'upsells', label: 'Upsells', icon: TrendingUp },
  { id: 'downsells', label: 'Downsells', icon: TrendingDown, disabled: true },
  { id: 'fallbacks', label: 'Fallbacks', icon: Shield, disabled: true },
]

export function BuilderTabs({ activeTab, onChange }: BuilderTabsProps) {
  return (
    <div className="flex border-b border-default-200">
      {TABS.map(({ id, label, icon: Icon, disabled }) => (
        <button
          key={id}
          className={`flex items-center gap-1.5 px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
            disabled
              ? 'border-transparent text-default-300 cursor-not-allowed'
              : activeTab === id
                ? 'border-primary text-primary'
                : 'border-transparent text-default-500 hover:text-default-700'
          }`}
          onClick={() => { if (!disabled) onChange(id) }}
          disabled={disabled}
          title={disabled ? 'Coming soon' : undefined}
        >
          <Icon className="w-4 h-4" />
          {label}
          {disabled && <span className="text-[10px] text-default-300 ml-1">(Coming Soon)</span>}
        </button>
      ))}
    </div>
  )
}
